export const RULE_UPDATED = 'rule-updated';
export const IMPORT_FINISHED = 'import-finished';